import { getSupportedLocales } from '@palqee/intl'

const supportedLocales = getSupportedLocales()
export const EN_LOCALE = supportedLocales[0]
export const PT_LOCALE = supportedLocales[1]
export const DE_LOCALE = supportedLocales[2]
export const DEFAULT_LOCALE = EN_LOCALE

export const DATE_FORMAT_1 = 'DD/MM'
export const DATE_FORMAT_2 = 'MM/DD'
export const SUPPORTED_DATE_FORMATS = [DATE_FORMAT_1, DATE_FORMAT_2]
export const DEFAULT_DATE_FORMAT = DATE_FORMAT_1

// relying on Intl.NumberFormat, which uses lcoale for formatting numbers
export const NUMBER_FORMAT_1 = EN_LOCALE // 1,234.56
export const NUMBER_FORMAT_2 = PT_LOCALE // 1.234,56
export const SUPPORTED_NUMBER_FORMATS = [NUMBER_FORMAT_1, NUMBER_FORMAT_2]
export const DEFAULT_NUMBER_FORMAT = NUMBER_FORMAT_1
